import { format } from 'date-fns';
import { allLangs, defaultLang } from 'src/locales';
import { localStorageGetItem } from './storage-available';

const langVariants = {
  en: 'en-US',
  it: 'it-IT',
};

export const getDateStringFormate = () => {
  const langStorage = localStorageGetItem('i18nextLng');

  const currentLang = allLangs.find((lang) => lang.value === langStorage) || defaultLang;

  const currentLangValue: string = currentLang.value;

  const currentDate = new Date();
  const options: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };
  // @ts-ignore
  return currentDate.toLocaleDateString(langVariants[currentLangValue], options);
};

/**
 * Returns date in dd-mm-yyyy format for file exports
 */
export const getDateForFileExport = (date: Date = new Date()): string => format(date, 'dd-MM-yyyy');
